import React from "react"
import Radium from "radium";
import {Icon} from "semantic-ui-react";
import GreenPlusButton from "components/Buttons/GreenPlusButton";
import RedMinusButton from "components/Buttons/RedMinusButton";

const styles = {
    multipleSelect: {
        title: {
            backgroundColor:'#465962',
            width:'100%',
            textAlign: 'center',
            color:'#fff',
            height:25,
            fontSize:'0.9em',
            lineHeight:'25px'
        },
        container: {
            display: 'inline-block',
            width:'45%',
            border: '1px solid #465962',
            borderRadius: '4px',
            height:'100%'
        },
        list: {
            width:'100%',
            height:175,
            overflowY: 'auto'
        },
        item: {
            width:'100%',
            minHeight:25,
            height:'auto',
            fontSize:'0.8em',
            padding:"0 5px",
            lineHeight:"25px",
            cursor:'pointer',
            ':hover': {
                backgroundColor:'rgba(0,0,0,0.05)'
            }
        },
        middle: {
            display: 'inline-block',
            width:'10%',
            height:'100%',
            paddingLeft:5,
            paddingRight:5
        }
    }
};

const _selectedItem = (selected) => (
    {
        width:'100%',
        minHeight:25,
        fontSize:'0.8em',
        padding:"0 5px",
        lineHeight:"25px",
        cursor:'pointer',
        backgroundColor: selected ? 'rgba(40,48,159,0.3)' : 'transparent',
        ':hover': {
            backgroundColor: selected ? 'rgba(40,48,159,0.5)' : 'rgba(0,0,0,0.05)'
        }
    }
)

const _addedItem = (selected) => (
    {
        width:'100%',
        minHeight:25,
        fontSize:'0.8em',
        padding:"0 5px",
        lineHeight:"25px",
        cursor:'pointer',
        backgroundColor: selected ? 'rgba(103, 191, 115, 0.7)' : 'rgba(103, 191, 115, 0.5)',
        ':hover': {
            backgroundColor:'rgba(103, 191, 115, 0.7)'
        }
    }
)

const _removedItem = (selected) => (
    {
        width:'100%',
        minHeight:25,
        fontSize:'0.8em',
        padding:"0 5px",
        lineHeight:"25px",
        cursor:'pointer',
        backgroundColor: selected ? 'rgba(169, 0, 10, 0.7)' : 'rgba(169, 0, 10, 0.5)',
        ':hover': {
            backgroundColor:'rgba(169, 0, 10, 0.7)'
        }
    }
)


class MultipleSelect extends React.Component{

    constructor(props){
        super(props)

        this.state = {
            selection1: new Set([]),
            selection2: new Set([])
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    toggleSelectionSet1(s){
        let newStateSelect = this.state.selection1.has(s) ? this.state.selection1.delete(s) : this.state.selection1.add(s);
        // Force a render with a simulated state change
        this.setState({ state: { selection1: newStateSelect, ...this.state} });
    }

    toggleSelectionSet2(s){
        let newStateSelect = this.state.selection2.has(s) ? this.state.selection2.delete(s) : this.state.selection2.add(s);
        // Force a render with a simulated state change
        this.setState({ state: { selection2: newStateSelect, ...this.state} });
    }

    addToSet = () => {
        let factory = this.props.factory;

        Array.from(this.state.selection1).forEach( elt => {
            if(elt.persisted)
            {
                factory.tmp.remove = factory.tmp.remove.filter( (i) => i.id !== elt.id)
            }
            else{
                factory.tmp.add.push(elt)
            }
        })

        this.state.selection1.clear()
        this.state.selection2.clear()

        // Force a render with a simulated state change
        this.setState({ state: this.state });



    };

    removeFromSet = () => {
        let { factory } = this.props;

        Array.from(this.state.selection2).forEach( elt => {
            // Si non persisté, on le retire des éléments à ajouter
            if(!elt.persisted)
            {
                factory.tmp.add = factory.tmp.add.filter( (i) => i.id !== elt.id)
            }
            else {
                factory.tmp.remove.push(elt)
            }
        })

        this.state.selection1.clear()
        this.state.selection2.clear()


        // Force a render with a simulated state change
        this.setState({ state: this.state });


    }

    render(){
        const { factory, disabled } = this.props;
        const { selection1, selection2 } = this.state;
        return (
            <div style={{width:'100%', height:200, display:'flex'}}>
                {!disabled && (
                <div style={styles.multipleSelect.container}>
                    <div style={styles.multipleSelect.title}>
                        { factory.listLabel }
                    </div>

                    <div style={styles.multipleSelect.list}>
                        {
                            factory.tmp.remove.map( s => (
                                <div key={"selected_remove_"+s.id} style={_removedItem(selection1.has(s))}  onClick={(e)=> {if(e !== undefined) e.preventDefault();this.toggleSelectionSet1(s)}}><Icon name="minus" size="tiny" color="red"/> {s.code}</div>
                            ))
                        }
                        {
                            factory.list
                                .filter( (listElt) => {return factory.selected.findIndex( (elt) => elt.id === listElt.id) <= -1 })
                                .filter( (listElt) => {return factory.tmp.add.findIndex( (elt) => elt.id === listElt.id) <= -1 })
                                .map( s => (
                                    <div style={_selectedItem(selection1.has(s)) } key={"list_"+s.id} onClick={(e)=> {if(e !== undefined) e.preventDefault();this.toggleSelectionSet1(s)}}>{s.code}</div>
                                ))
                        }
                    </div>

                </div>
                )}
                {!disabled && (
                <div style={styles.multipleSelect.middle}>
                    <GreenPlusButton onClick={this.addToSet} text={<Icon name="add" style={{margin:0}}/>} style={{width:'100%',marginBottom:10}}/>
                    <RedMinusButton onClick={this.removeFromSet} text={<Icon name="minus" style={{margin:0}}/>}  style={{width:'100%'}}/>
                </div>
                )}

                <div style={styles.multipleSelect.container}>
                    <div style={styles.multipleSelect.title}>
                        <b>{ factory.selectedLabel }</b>
                    </div>

                    <div style={styles.multipleSelect.list}>
                        {
                            factory.tmp.add.map( s => (
                                <div key={"selected_add_"+s.id} style={_addedItem(selection2.has(s))} onClick={(e)=> {if(e !== undefined) e.preventDefault();this.toggleSelectionSet2(s)}}><Icon name="add" size="tiny" color="green"/> {s.code}</div>
                            ))
                        }
                        {
                            factory.selected
                                .filter( (listElt) => {return factory.tmp.remove.findIndex( (elt) => elt.id === listElt.id) <= -1 })
                                .map( s => (
                                    <div key={"selected_"+s.id}
                                         style={_selectedItem(selection2.has(s)) }
                                         onClick={(e)=> {if(e !== undefined) e.preventDefault();this.toggleSelectionSet2(s)}}>{s.code}</div>
                            ))
                        }
                    </div>


                </div>
            </div>
        )
    }

}

export default Radium(MultipleSelect)